import { config } from 'lib-shared-backend-config';

import { ajaxSend, ApiBasePath } from '../../../../../api/api';

export function upload(
  file: any,
  isPublic = true,
): ReturnType<typeof ajaxSend> | undefined {
  if (file === undefined || file === null) {
    console.error('upload file - No valid file in payload given.');
    return Promise.reject();
  }

  const data = new FormData();
  data.append('file', file);

  return ajaxSend({
    path: isPublic === true ? `/public/attachment` : `/private/attachment`,
    method: 'POST',
    basePath: ApiBasePath.Files,
    headers: {
      contentType: 'multipart/form-data',
    },
    data: data,
  }).then((response: any) => {
    if (
      response.data &&
      response.data.relative_uri &&
      typeof response.data.relative_uri === 'string'
    ) {
      response.data.link = config.url.files + response.data.relative_uri;
      return response;
    }
    return response;
  });
}
